<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click.stop>
        <div class="bg-white popup">
          <div class="popup-header">
            <h1 class="title">Editar: {{currentPlan.nombre }}</h1>
            <img src="@/assets/images/ic_close.svg" class="close_icon" @click="closePopup()" />
          </div>
          <div class="popup-body">
            <h3 class="subtitle">ID del plan: {{ currentPlan.id_plan }}</h3>
         
          <h4>Datos del plan</h4>
          <div class="fields">
            <div class="input-50">
              <label>Título*</label>
              <br/>
              <input
                type="text"
                required
                v-model="currentPlan.nombre"/>
            </div>
            <div class="input-50">
              <label>Categoría</label>
              <br/>
              <select v-model="currentPlan.categoria">
                <option value="">Selecciona una categoría</option>                
                <option value="bienestar">Bienestar</option>
                <option value="deportes">Deportes</option>
                <option value="gastro">Gastro</option>
                <option value="ocio">Ocio</option>
                <option value="viaje">Viajes</option>
              </select>
            </div>
          </div>
          <div class="fields" style="margin-top: 20px;">
            <div class="input-100">
              <label>Descripción*</label>
              <br/>
              <input
                type="text"
                required
                v-model="currentPlan.descripcion"/>
            </div>
          </div>
          <div class="fields" style="margin-top: 20px;">
            <div class="input-33">
              <label>Ciudad</label>
              <br/>
              <select v-model="currentPlan.ciudad">
                <option value="">Selecciona una ciudad</option>                
                <option value="A Coruña">A Coruña</option>
                <option value="Albacete">Albacete</option>
                <option value="Alicante">Alicante</option>
                <option value="Almería">Almería</option>
                <option value="Asturias">Asturias</option>
                <option value="Ávila">Ávila</option>
                <option value="Badajoz">Badajoz</option>
                <option value="Barcelona">Barcelona</option>
                <option value="Bilbao">Bilbao</option>
                <option value="Burgos">Burgos</option>
                <option value="Cádiz">Cádiz</option>
                <option value="Cantabria">Cantabria</option>
                <option value="Ciudad Real">Ciudad Real</option>
                <option value="Córdoba">Córdoba</option>
                <option value="Cuenca">Cuenca</option>
                <option value="Donosti">Donosti</option>
                <option value="Ferrol">Ferrol</option>
                <option value="Formentera">Formentera</option>
                <option value="Fuerteventura">Fuerteventura</option>
                <option value="Gijón">Gijón</option>
                <option value="Girona">Girona</option>
                <option value="Gran Canaria">Gran Canaria</option>
                <option value="Granada">Granada</option>
                <option value="Guadalajara">Guadalajara</option>
                <option value="Huelva">Huelva</option>
                <option value="Huesca">Huesca</option>
                <option value="Ibiza">Ibiza</option>
                <option value="Islas Baleares">Islas Baleares</option>
                <option value="Jaén">Jaén</option>
                <option value="La Gomera">La Gomera</option>
                <option value="Las Palmas">Las Palmas</option>
                <option value="Lanzarote">Lanzarote</option>
                <option value="León">León</option>
                <option value="Lleida">Lleida</option>
                <option value="Logroño">Logroño</option>
                <option value="Lugo">Lugo</option>
                <option value="Madrid">Madrid</option>
                <option value="Málaga">Málaga</option>
                <option value="Mallorca">Mallorca</option>
                <option value="Menorca">Menorca</option>
                <option value="Mérida">Mérida</option>
                <option value="Murcia">Murcia</option>
                <option value="Navarra">Navarra</option>
                <option value="Oviedo">Oviedo</option>
                <option value="Palencia">Palencia</option>
                <option value="Pamplona">Pamplona</option>
                <option value="Pirineo Aragonés">Pirineo Aragonés</option>
                <option value="Salam">Salamanca</option>
                <option value="Santiago">Santiago</option>
                <option value="Sevilla">Sevilla</option>
                <option value="Soria">Soria</option>
                <option value="Tarragona">Tarragona</option>
                <option value="Tenerife">Tenerife</option>
                <option value="Teruel">Teruel</option>
                <option value="Toledo">Toledo</option>
                <option value="Valencia">Valencia</option>
                <option value="Valladolid">Valladolid</option>
                <option value="Vigo">Vigo</option>
                <option value="Vitoria - Gasteiz">Vitoria - Gasteiz</option>
                <option value="Zamora">Zamora</option>
                <option value="Zaragoza">Zaragoza</option>
              </select>
            </div>
            <div class="input-33">
              <label>Fecha</label>
              <br/>
              <input
                type="date"
                required
                class="expiration-date"
                v-model="date" />
            </div>
            <div class="input-33">
              <label>Hora</label>
              <br/>
              <input
                type="time"
                v-model="currentPlan.hora"/>
            </div>
          </div>
          <div class="fields" style="margin-top: 20px;">
            <div class="input-33">
              <label>Plazas máximas</label>
              <br/>
              <input
                type="number"
                required
                class="expiration-date"
                v-model="currentPlan.plazas_maximas" />
            </div>
            <div class="input-33">
              <label>Edad mínima</label>
              <br/>
              <input
                type="number"
                v-model="currentPlan.min_edad"/>
            </div>
            <div class="input-33">
              <label>Edad máxima</label>
              <br/>
              <input
                type="number"
                v-model="currentPlan.max_edad"/>
            </div>
          </div>
          <div class="fields" style="margin-top: 20px;">
            <div class="input-33">
              <h4>Imagen</h4>
              <div class="gallery-input-33">
                <img :src="image" class="image-gallery" @click="openImageModal()" @dragover.prevent="handleDragOver" @drop="handleDrop"/>
                <img v-if="image != defaultGalleryPicture" src="@/assets/images/ic_close.svg" class="image-gallery-delete" @click="clearImage()" />
              </div>
              <input ref="imagePicker" type="file" @change="onFileChange" accept="image/*" style="display: none;" />
            </div>
            <div class="input-66">
              <h4>Organizadores</h4>
              <table style="width: 100%;">
                <thead>
                  <tr>
                      <th style="width: 20%;">ID</th>
                      <th style="width: 40%;">Nombre</th>
                      <th style="width: 40%;">Email</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="(item, index) in currentPlan.organizadores"
                    :key="item.codigo"
                    :class="index % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
                  >
                    <td style="text-align: center;">{{ item.ID }}</td>
                    <td style="text-align: center;">{{ item.usuario }}</td>
                    <td style="text-align: center;">{{ item.email }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          </div>
          <div class="popup-footer">
            <button @click="closePopup()" class="secondary_button">Cancelar</button>
            <button @click="saveClicked()" class="main_button">Guardar</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue';
  import { useLoadingStore } from "@/stores/loadingStore";
  import defaultGalleryPicture from '@/assets/images/ic_gallery.png';
  import { refreshToken } from "@/services/authService";
  import { useRouter } from 'vue-router';
  
  const props = defineProps({
    plan: Object,
  });
  
  
  const emit = defineEmits(['planParticularChanged', 'planParticularDetailsPopupCancelled', 'planParticularDetailsErrorHappened']);

  const visible = ref(false);
  const error = ref(null);
  const currentPlan = ref(null);
  const imagePicker = ref(null)
  const loadingStore = useLoadingStore();
  const router = useRouter();
  const date = ref(null);

  watch(() => props.plan, (newVal) => {
    currentPlan.value = newVal;
    if (newVal != null) {
      image.value = newVal.imagen ?? defaultGalleryPicture;
      if (newVal.fecha != null) {
        date.value = toInputFormat(newVal.fecha);
      } else {
        date.value = null;
      }
    }
    visible.value = !!newVal;
  });
  
  function toInputFormat(dateStr) {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  }

  const closePopup = () => {
    currentPlan.value = null;
    image.value = null;
    emit('planParticularDetailsPopupCancelled');
  };

  const saveClicked = async () => {
    loadingStore.setLoading(true);
    error.value = null;

    currentPlan.value.imagenes = [];
    var numImage = 0;
    if (image.value !== defaultGalleryPicture) {
      currentPlan.value.imagenes[numImage] = {"id_promocion": currentPlan.value.id_promo, "num_foto": numImage, "imagen_url": image.value };
      numImage++;
    }

    currentPlan.value.fecha = date.value ? date.value.split("-").reverse().join("-") : null;

    try {
      let response = await savePlanInAPI();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await savePlanInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        emit('planParticularDetailsErrorHappened', 'Se ha producido un error guardando el plan.');
        loadingStore.setLoading(false);
        return;
      }

      const data = await response.json();

      if (data.errors) {
        emit('planParticularDetailsErrorHappened', data.message);
        loadingStore.setLoading(false);
      } else {
        error.value = null;
        loadingStore.setLoading(false);
        emit('planParticularChanged');
    }      
    } catch (exception) {
      emit('planParticularDetailsErrorHappened', exception.message);
    }
  }

  async function savePlanInAPI() {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/set_details", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id'),
        "plan": currentPlan.value
      }),
    });
  
  }

  const image = ref(null);

  function openImageModal() {
    imagePicker.value.click();
  }

  function clearImage() {
    image.value = defaultGalleryPicture;
  }

  function handleDragOver(event) {
    event.preventDefault();
  }

  function handleDrop(event) {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      managePicture(file);
    }
  }

  function onFileChange(event) {
    const file = event.target.files[0];
    if (file) {
      managePicture(file);
    } 
  }

  function managePicture(file) {
    if (!file.type.startsWith('image/')) {
      alert("Selecciona un archivo de imagen válido")
      return
    }

    if (file.size <= 1024 * 1024) {
      const reader = new FileReader()
      reader.onload = e => setImage(e.target.result)
      reader.readAsDataURL(file)
      return
    }
    

    const reader = new FileReader()
    reader.onload = e => {
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        const MAX_WIDTH = 1024
        const MAX_HEIGHT = 1024
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }

        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)
        canvas.toBlob(
          blob => {
            if (blob.size > 1024 * 1024) {
              alert("No se pudo comprimir la imagen por debajo de 1MB")
              return
            }
            const blobReader = new FileReader()
            blobReader.onload = e2 => {
              setImage(e2.target.result)
            }
            blobReader.readAsDataURL(blob)
          },
          'image/jpeg',
          0.8 // calidad 80%
        )
      }
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  }

  function setImage(newUrl) {
    image.value = newUrl;
  }

  </script>
  
  <style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  
  .bg-white {
    background-color: white;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 90%;
    max-width: 1800px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-height: 90vh;
  }
  
  .popup-header {
    padding: var(--spacing-md) var(--spacing-lg);
    border-bottom: 1px solid var(--light-gray);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: var(--text-color-dark);
    margin: 0;
  }

  .close_icon {
    position: absolute;
    right: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity var(--transition-fast);
  }

  .close_icon:hover {
    opacity: 1;
  }

  .popup-body {
    padding: var(--spacing-lg);
    overflow-y: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
  }

  .popup-footer {
    padding: var(--spacing-md) var(--spacing-lg);
    border-top: 1px solid var(--light-gray);
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-md);
    background-color: var(--white);
  }

  .secondary_button, .main_button {
    width: auto;
    min-width: 120px;
  }

  .popup {
    position: relative;
  }

  .circular-image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 20px;
  }

  .user-info {
    display: flex;
    padding-top:10px;
    align-items: center;
  }

  .user-text {
    display: flex;
    flex-direction: column;
  }

  .user-text h2 {
    width: 100%;
  }
  .questions {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    border-top: 1px solid var(--very-clear-gray);
    padding-top: 15px;
  }

  .questions h3 {
    font-weight: normal;
  }

  .questions label {
    margin-top: 10px;
  }

  .products {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    border-top: 1px solid var(--very-clear-gray);
    padding-top: 15px;
  }

  .products h3 {
    font-weight: normal;
  }

  .button-disabled {
    opacity: 0.5;
  }

  .button-enabled {
    opacity: 1;
  }

  .title {
    text-align: center;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .subtitle {
    text-align: center;
  }

  .subtitle-codes {
    text-align: center;
    color: var(--clear-gray);
  }
  
  .subtitle-codes-mini {
    font-size: 12px;
    font-style: normal;
    font-weight: normal;
  }
  ::v-deep(.ql-container) {
    font-family: "GatterSans" !important;
    font-size: 16px !important;
  }

  ::v-deep(.ql-toolbar) {
    box-sizing: border-box;
    border: 1px solid var(--gray) !important;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  ::v-deep(.ql-editor) {
    box-sizing: border-box;
    border-left: 1px solid var(--gray) !important;
    border-right: 1px solid var(--gray) !important;
    border-bottom: 1px solid var(--gray) !important;
    border-top: 0px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  ::v-deep(.ql-snow) {
    border: 0px;
  }

  /* Modern Flex Grid (gap-based, no margin hacks) */
  .fields {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-sm);
  }

  .input-25  { flex: 1 1 calc(25% - var(--spacing-md)); min-width: 150px; }
  .input-33  { flex: 1 1 calc(33.33% - var(--spacing-md)); min-width: 200px; }
  .input-50  { flex: 1 1 calc(50% - var(--spacing-md)); min-width: 260px; }
  .input-66  { flex: 1 1 calc(66.66% - var(--spacing-md)); min-width: 320px; }
  .input-100 { flex: 1 1 100%; }

  .input-25 input, .input-25 select,
  .input-33 input, .input-33 select,
  .input-50 input, .input-50 select,
  .input-66 input, .input-66 select,
  .input-100 input, .input-100 select, .input-100 textarea {
    width: 100%;
    box-sizing: border-box;
  }

  .gallery-input-33 {
    flex: 1 1 calc(33.33% - var(--spacing-md));
    min-width: 180px;
    position: relative;
  }

  .gallery-input-33 img {
    border-radius: var(--radius-md);
  }

  .datepicker-container {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: var(--spacing-sm);
    box-sizing: border-box;
    border-radius: var(--radius-md);
    border: 1px solid var(--border-color);
    background-color: var(--white);
  }

  .content-preview {
    margin-top: var(--spacing-md);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-md);
    padding: var(--spacing-md);
    background-color: var(--very-clear-gray);
  }

  .input-checkbox {
    display: flex;
    align-items: center;
    margin-top: var(--spacing-sm);
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
  }

  .fields input:disabled {
    background-color: var(--very-clear-gray) !important;
    border-color: var(--border-color-subtle) !important;
    color: var(--text-color-placeholder);
  }

  .expiration-date {
    box-sizing: border-box;
    border-radius: var(--radius-md);
    border: 1px solid var(--border-color);
    background-color: var(--white);
  }

  .expiration-date-container {
    width: 100%;
    margin-top: 4px;
    display: flex;
    justify-content: center;
  }

  .image-gallery {
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    background-color: var(--very-clear-gray);
    border-radius: var(--radius-md);
    border: 1px dashed var(--border-color);
    display: block;
    cursor: pointer;
    transition: border-color var(--transition-fast);
  }

  .image-gallery:hover {
    border-color: var(--primary-color);
  }

  .image-gallery-delete {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    cursor: pointer;
    border-radius: 50%;
    background-color: var(--white);
    box-shadow: var(--shadow-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    box-sizing: border-box;
  }

  .add_button {
    padding-top: var(--spacing-md);
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    color: var(--text-color-dark);
    transition: opacity var(--transition-fast);
  }

  .add_button:hover {
    opacity: 0.75;
  }

  .without-top-padding {
    padding-top: 0 !important;
  }

  .centered {
    justify-content: center !important;
  }

  .campo-pedir-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
    padding-top: 8px;
    padding-left: 8px;
    opacity: 0.7;
    transition: opacity var(--transition-fast);
  }

  .campo-pedir-icon:hover {
    opacity: 1;
  }
  </style>
  